import translationsAPI from '../../api/translations'
import translationsBackup from '../../assets/translations_backup.json'
import _ from 'underscore'
import log from 'loglevel'

let tag = 'biWebApp'
let languages = process.env.VUE_APP_LANGUAGES

// initial state
const state = {
  data: {},
  loaded: false,
  languages: Object.values(JSON.parse(languages)),
  currentLanguage: ''
}

const getters = {
  translations: state => state.data,
  translationsLoaded: state => state.loaded,
  languages: state => state.languages,
  currentLanguage: state => state.currentLanguage,
  translation: (state, getters) => (key, scope) => {
    let data = getters.translations
    let item
    // fallback languages
    let lang = getters.currentLanguage
    if (getters.translationsLoaded) {
      if (!data[lang]) {
        lang = getters.languages[0]
        if (!data[lang]) {
          return key
        }
      } else {
        while (!data[lang][key]) {
          let langIndex = _.indexOf(getters.languages, lang)
          if (langIndex <= 0) {
            return key
          } else {
            // fallback to previous lang if translation is missing
            // lang = getters.languages[--langIndex]
            // fallback to first ('EN') if translation is missing
            lang = 'en'
          }
        }
      }

      item = data[lang][key]
      let compiled = _.template(item)
      if (scope) {
        return compiled(scope)
      }
      return item
    }
  }
}

const actions = {
  fetchTranslations ({ commit, getters }) {
    let promises = []
    _.each(state.languages, lang => {
      promises.push(translationsAPI.fetchTranslations(lang, tag))
    })
    return Promise.all(promises)
      .then(responses => {
        // log.info('Fetch translations responses: ', responses)
        responses.forEach(response => {
          getters.languages.forEach(lang => {
            let translation = {}
            translation =
              response.errorCode ? translationsBackup.find(trans => trans['en']) : responses.find(trans => trans[lang])
            commit('SET_TRANSLATION', translation)
          })
        })
        commit('TRANSLATIONS_LOADED')
      }, error => {
        log.info('Fetch translations error: ', error)
        commit('TRANSLATIONS_LOADED')
      })
  }
}

const mutations = {
  SET_TRANSLATION (state, data) { state.data = { ...state.data, ...data } },
  SET_LANGUAGE (state, language) { state.currentLanguage = language },
  TRANSLATIONS_LOADED (state) { state.loaded = true }
}

export default {
  state,
  getters,
  actions,
  mutations
}
